import { Field, Option } from "components/dynamic/DynamicForm";
import { TFunction } from "i18next";
import { enumToOptions } from "services/helper";
import { ActivityType, CompanyStage, CompanyType } from "types/companyTypes";

export const businessSchema = (
  t: TFunction<"translation", undefined>,
  industriesOptions: Option[],
  isViewMode: boolean
): Field[] => {
  return [
    {
      name: "industrySectorId",
      label: t("company.fields.industrySectorId"),
      type: "select",
      options: industriesOptions,
      required: true,
      disabled: isViewMode,
    },
    {
      name: "industrySectorOther",
      label: t("company.fields.industrySectorOther"),
      type: "text",
      required: true,
      disabled: isViewMode,
      showWhen: {
        field: "industrySectorId",
        optionKey: "OTHER",
      },
    },
    {
      name: "activityType",
      label: t("company.fields.activityType"),
      type: "select",
      options: enumToOptions(ActivityType, t, "company.activityTypes"),
      required: true,
      disabled: isViewMode,
    },
    {
      name: "activityDescription",
      label: t("company.fields.activityDescription"),
      type: "textarea",
      rows: 3,
      required: true,
      disabled: isViewMode,
    },
    {
      name: "companyType",
      label: t("company.fields.companyType"),
      type: "select",
      required: true,
      disabled: isViewMode,
      options: enumToOptions(CompanyType, t, "company.companyTypes"),
    },
    {
      name: "companyTypeOther",
      label: t("company.fields.companyTypeOther"),
      type: "text",
      required: true,
      disabled: isViewMode,
      showWhen: {
        field: "companyType",
        equals: "OTHER",
      },
    },

    {
      name: "totalStaffCount.production",
      label: t("company.fields.production"),
      type: "number",
      disabled: isViewMode,
      required: true,
    },
    {
      name: "totalStaffCount.administrative",
      label: t("company.fields.administrative"),
      type: "number",
      disabled: isViewMode,
      required: true,
    },
    {
      name: "foundationYear",
      label: t("company.fields.foundationYear"),
      type: "date",
      disabled: isViewMode,
      picker: "year",
      required: true,
    },
    {
      name: "isKnowledgeBased",
      label: t("company.fields.isKnowledgeBased"),
      type: "checkbox",
      disabled: isViewMode,
    },
    {
      name: "knowledgeBasedYear",
      label: t("company.fields.knowledgeBasedYear"),
      type: "date",
      picker: "year",
      disabled: isViewMode,
      required: true,
      showWhen: {
        field: "isKnowledgeBased",
        equals: true,
      },
    },
    {
      name: "isTechnologist",
      label: t("company.fields.isTechnologist"),
      type: "checkbox",
      disabled: isViewMode,
    },
    {
      name: "companyStage",
      label: t("company.fields.companyStage"),
      type: "select",
      disabled: isViewMode,
      options: enumToOptions(CompanyStage, t, "company.companyStages"),
      required: true,
      showWhen: {
        field: "isTechnologist",
        equals: true,
      },
    },
    {
      name: "technologistLicenseNumber",
      label: t("company.fields.technologistLicenseNumber"),
      type: "number",
      disabled: isViewMode,
      required: true,
      showWhen: {
        field: "isTechnologist",
        equals: true,
      },
    },
    {
      name: "technologistLicenseDate",
      label: t("company.fields.technologistLicenseDate"),
      type: "date",
      disabled: isViewMode,
      required: true,
      showWhen: {
        field: "isTechnologist",
        equals: true,
      },
    },
    {
      name: "meta.technologistLicenseRefrence",
      label: t("company.fields.technologistLicenseRefrence"),
      type: "text",
      disabled: isViewMode,
      required: true,
      showWhen: {
        field: "isTechnologist",
        equals: true,
      },
    },
    {
      name: "licenseNumber",
      label: t("company.fields.licenseNumber"),
      type: "number",
      disabled: isViewMode,
    },
    {
      name: "licenseDate",
      label: t("company.fields.licenseDate"),
      type: "date",
      disabled: isViewMode,
    },
    {
      name: "isListed",
      label: t("company.fields.isListed"),
      type: "checkbox",
      disabled: isViewMode,
    },
    {
      name: "hasExport",
      label: t("company.fields.hasExport"),
      type: "checkbox",
      disabled: isViewMode,
    },
    // {
    //   name: "exportAmount",
    //   label: t("company.fields.exportAmount"),
    //   type: "price",
    //   disabled: isViewMode,
    // },
    // {
    //   name: "meta.exportVolumeUnit",
    //   label: t("company.fields.exportVolumeUnit"),
    //   type: "select",
    //   disabled: isViewMode,
    //   options: enumToOptions(ExportType, t, "exportTypes"),
    // },
    // {
    //   name: "meta.exportVolumeUnitOther",
    //   label: t("company.fields.exportVolumeUnitOther"),
    //   type: "text",
    //   disabled: isViewMode,
    //   required: true,
    //   showWhen: {
    //     field: "meta.exportVolumeUnit",
    //     equals: "OTHER",
    //   },
    // },
    // {
    //   name: "exportVolume",
    //   label: t("company.fields.exportVolume"),
    //   type: "number",
    //   disabled: isViewMode,
    // },
  ];
};
